import React from 'react';
/* eslint-disable import/no-anonymous-default-export */
import BadlyIcon from '../../../images/smiles/badly.svg';
import BadlyIconWhite from '../../../images/smiles/badly-white.svg';
import NeutralIcon from '../../../images/smiles/neutral.svg';
import NeutralIconWhite from '../../../images/smiles/neutral-white.svg';
import GoodIcon from '../../../images/smiles/good.svg';
import GoodIconWhite from '../../../images/smiles/good-white.svg';

import {
	BaseText,
	NumeralIndex,
	CountryName,
	getDefaultTooltip,
} from './components';

export const getHappinessLabel = (value, resultType = 'html', isIconsWhite) => {
	let textValue = 'Low';
	let imgValue = <img src={isIconsWhite ? BadlyIconWhite : BadlyIcon} />;
	if (value >= 4.79) {
		if (resultType === 'string') textValue = 'Medium';
		imgValue = <img src={isIconsWhite ? NeutralIconWhite : NeutralIcon} />;
	}
	if (value >= 5.56) {
		if (resultType === 'string') textValue = 'High';
		imgValue = <img src={isIconsWhite ? GoodIconWhite : GoodIcon} />;
	}
	if (value >= 6.24) {
		if (resultType === 'string') textValue = 'Very high';
		imgValue = <img src={isIconsWhite ? GoodIconWhite : GoodIcon} />;
	}
	if (resultType === 'string') return textValue;
	return imgValue;
};
export const getCostOfLiving = (value, resultType = 'html') => {
	let textValue = 'Low';
	if (value >= 37.42) textValue = 'Medium';
	if (value >= 48.54) textValue = 'High';
	if (value >= 66.87) textValue = 'Very high';
	if (resultType === 'string') return textValue;
	return <div className="font-bold">{textValue}</div>;
};
export const getSustainabilityLabel = (value, resultType = 'html') => {
	let textValue = 'Low';
	if (value >= 61.64) textValue = 'Medium';
	if (value >= 68.98) textValue = 'High';
	if (value >= 74.41) textValue = 'Very high';
	if (resultType === 'string') return textValue;
	return <div className="font-bold">{textValue}</div>;
};
export default [
	NumeralIndex({
		Header: () => (
			<div className="desktop-only --inline  text-mono text-mono--grey">
				Quality index
			</div>
		),
		title: 'Quality index',
		accessor: 'eqol_rank',
	}),
	CountryName(),
	BaseText({
		HeaderName: 'Score',
		HeaderTooltip: `<p>The Quality of Life index is worth 25% of the Global Passport Index score. To measure the quality of life six indicators were measured: sustainable development (weighted at 30% of the quality of life score), the cost of living (weighted at 20%), the protection of personal freedom (weighted at 20%), the “happiness” of the citizens (weighted at 10%), environmental performance (weighted at 10%), and migrant acceptance (weighted at 10%).</p>
		<br />
		<p>This table provides a visual representation of three indicators: Sustainable Development, Cost of Living, and the level of “happiness” of the citizens.</p>
		`,
		HeaderTooltipType: 'html',
		accessor: 'eqol_points',
		minWidth: 92,
	}),
	BaseText({
		HeaderName: 'Sustainable Development',
		accessor: 'sdg_idx_points',
		minWidth: 160,
		desktopOnly: true,
		Cell: ({ value }) => getSustainabilityLabel(value),
	}),

	BaseText({
		HeaderName: 'Cost of Living',
		accessor: 'col_idx_value',
		minWidth: 230,
		desktopOnly: true,
		Cell: ({ value }) => getCostOfLiving(value),
	}),

	BaseText({
		HeaderName: 'Happiness',
		accessor: 'whr_idx_value',
		Cell: ({ value }) => getHappinessLabel(value),
		maxWidth: 120,
		desktopOnly: true,
	}),
];
